import { DatePipe } from "@angular/common";
import { Sort } from "../../UI-Components/Sort/sort";
import { AgencyAction } from "./AgencyAction.model";
import { AnalystModel } from "./Analyst.model";
import { DeterminationModel } from "./Determination.model";
import { DocumentTypeModel } from "./DocumentType.model";
import { ProjectType } from "./projectType.model";
import { Regulation } from "./regulation.model";
import { StateAgency } from "./StateAgency.model";
import { ThresholdCategory } from "./threshold-category.model";
import { TownModel } from "./town.model";
import { Watershed } from "./watershed.model";

const ConstRegulations = "regulations";
const ConstThresholds = "thresholds";
const ConstAgencyActions = "agencyActions";
const ConstAgencies = "agencies";
const ConstWatershed = "watershed";
const ConstDetermination = "determination";
const ConstSubmittalDateTo = "submittalDateTo";
const ConstSubmittalDateFrom = "submittalDateFrom";
const ConstMepaAnalyst = "mepaAnalyst";
const ConstTown = "town";
const ConstProjectType = "projectType";
const ConstProjectName = "projectName";
const ConstProjectNumber = "projectNumber";

export class SearchProjectModel {
  public static readonly Const_Proponent_Name = "proponentName";
  public static get ConstSubmittalType(): string {
    return "submittalType";
  }
  public datePipe: DatePipe;

  constructor(
    public projectId: string,
    public projectNumber: string,
    public projectName: string,
    public submittalType: DocumentTypeModel,
    public town: TownModel,
    public townName: string,
    public submittalDateFrom: Date,
    public submittalDateTo: Date,
    public mepaAnalyst: AnalystModel,
    public status: number,
    public projectType: ProjectType,
    public proponentName: string,
    public determination: DeterminationModel,
    public watershed: Watershed,
    public agencies: StateAgency[],
    public agencyActions: AgencyAction[],
    public thresholds: ThresholdCategory[],
    public regulations: Regulation[],
    public statewide: boolean,
    public pageSize: number,
    public page: number,
    public sort: Sort,
    public isExactAgency: boolean = false,
    public isExactAction: boolean = false,
    public isExactThreshold: boolean = false,
    public isExactThresholdCat: boolean = false
  ) {}

  GetFilterList(datePipe: DatePipe): ChipSearchParameterModel[] {
    this.datePipe = datePipe;
    let chipSearchParameterList = [];

    this.FilterProjectNumber(chipSearchParameterList);
    this.filterProjectName(chipSearchParameterList);
    this.filterProjectType(chipSearchParameterList);
    this.filterTown(chipSearchParameterList);
    this.filterMepaAnalyst(chipSearchParameterList);

    if (this.proponentName != "") {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.proponentName,
          this.proponentName,
          SearchProjectModel.Const_Proponent_Name
        )
      );
    }

    if (
      this.submittalType != null &&
      this.submittalType.documentTypeId != null
    ) {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.submittalType.documentTypeId,
          this.submittalType.documentTypeName,
          SearchProjectModel.ConstSubmittalType
        )
      );
    }

    this.filterSubmittalDateFrom(chipSearchParameterList);
    this.filterSubmittalDateTo(chipSearchParameterList);
    this.filterDetermination(chipSearchParameterList);
    this.filterWatershed(chipSearchParameterList);
    this.filterAgencies(chipSearchParameterList);
    this.filterAgencyActions(chipSearchParameterList);
    this.filterThresholds(chipSearchParameterList);
    this.filterRegulations(chipSearchParameterList);

    return chipSearchParameterList;
  }

  private filterRegulations(chipSearchParameterList: any[]) {
    if (this.regulations != null && this.regulations.length > 0) {
      this.regulations.forEach((regulation) => {
        chipSearchParameterList.push(
          new ChipSearchParameterModel(
            regulation.regulationId,
            regulation.regulationNumber,
            ConstRegulations
          )
        );
      });
    }
  }

  private filterThresholds(chipSearchParameterList: any[]) {
    if (this.thresholds != null && this.thresholds.length > 0) {
      this.thresholds.forEach((threshold) => {
        chipSearchParameterList.push(
          new ChipSearchParameterModel(
            threshold.thresholdId,
            threshold.thresholdCategory,
            ConstThresholds
          )
        );
      });
    }
  }

  private filterAgencyActions(chipSearchParameterList: any[]) {
    if (this.agencyActions != null && this.agencyActions.length > 0) {
      this.agencyActions.forEach((agency) => {
        chipSearchParameterList.push(
          new ChipSearchParameterModel(
            agency.actionId,
            agency.actionName,
            ConstAgencyActions
          )
        );
      });
    }
  }

  private filterAgencies(chipSearchParameterList: any[]) {
    if (this.agencies != null && this.agencies.length > 0) {
      this.agencies.forEach((agency) => {
        chipSearchParameterList.push(
          new ChipSearchParameterModel(
            agency.agencyId,
            agency.agencyName,
            ConstAgencies
          )
        );
      });
    }
  }

  private filterWatershed(chipSearchParameterList: any[]) {
    if (this.watershed != null && this.watershed.watershedId != null) {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.watershed.watershedId,
          this.watershed.watershedName,
          ConstWatershed
        )
      );
    }
  }

  private filterDetermination(chipSearchParameterList: any[]) {
    if (
      this.determination != null &&
      this.determination.determinationId != null
    ) {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.determination.determinationId,
          this.determination.determinationName,
          ConstDetermination
        )
      );
    }
  }

  private filterSubmittalDateTo(chipSearchParameterList: any[]) {
    if (this.submittalDateTo != null) {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.submittalDateTo,
          this.datePipe.transform(this.submittalDateTo, "M/d/yyyy"),
          ConstSubmittalDateTo
        )
      );
    }
  }

  private filterSubmittalDateFrom(chipSearchParameterList: any[]) {
    if (this.submittalDateFrom != null) {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.submittalDateFrom,
          this.datePipe.transform(this.submittalDateFrom, "M/d/yyyy"),
          ConstSubmittalDateFrom
        )
      );
    }
  }

  private filterMepaAnalyst(chipSearchParameterList: any[]) {
    if (this.mepaAnalyst != null && this.mepaAnalyst.analystId != "") {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.mepaAnalyst.analystId,
          this.mepaAnalyst.firstName + " " + this.mepaAnalyst.lastName,
          ConstMepaAnalyst
        )
      );
    }
  }

  private filterTown(chipSearchParameterList: any[]) {
    if (this.town != null && this.town.TownId != -1) {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.town.TownId,
          this.town.TownName,
          ConstTown
        )
      );
    }
  }

  private filterProjectType(chipSearchParameterList: any[]) {
    if (this.projectType != null && this.projectType.projectTypeId != "") {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.projectType.projectTypeId,
          this.projectType.projectTypeName,
          ConstProjectType
        )
      );
    }
  }

  private filterProjectName(chipSearchParameterList: any[]) {
    if (this.projectName != "") {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.projectName,
          this.projectName,
          ConstProjectName
        )
      );
    }
  }

  private FilterProjectNumber(chipSearchParameterList: any[]) {
    if (this.projectNumber != "") {
      chipSearchParameterList.push(
        new ChipSearchParameterModel(
          this.projectNumber,
          this.projectNumber,
          ConstProjectNumber
        )
      );
    }
  }
}

export class ChipSearchParameterModel {
  constructor(
    public value: any,
    public text: any,
    public parameterName: string
  ) {}
}
